import {Sun, Moon} from 'lucide-react';
import {DesktopDropdown} from "./header/DesktopDropdown";
import {BrandName} from "../constants";

interface IHeaderProps {
    isLight: boolean;
    setIsLight: () => void;
}

export const Header: React.FC<IHeaderProps> = ({ isLight, setIsLight }) => {
    return (
        <header className="bg-gradient-to-r from-[#6366f1] to-[#FF8A3D] px-2 py-2 text-white fixed top-0 left-0 right-0 z-50">
            <nav
                className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
                aria-label="Main navigation"
            >
                <div className="flex items-center justify-between h-12 px-4 md:px-6">
                    {/* 左侧导航区 */}
                    <div className="flex items-center">
                        <a
                            className="flex-shrink-0 flex items-center text-base gap-1"
                            href="/"
                            aria-label="Home"
                        >
                            {/*<img*/}
                            {/*    src="/images/logo.svg"*/}
                            {/*    alt="ImagesAgent Logo"*/}
                            {/*    className="object-contain w-9 h-9"*/}
                            {/*    width={36}*/}
                            {/*    height={36}*/}
                            {/*/>*/}
                            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" className="w-9 h-9">
                                <defs>
                                    <linearGradient id="mergeGrad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#FFCDD2"></stop>
                                        <stop offset="100%" stopColor="#F44336"></stop>
                                    </linearGradient>
                                    <linearGradient id="mergeGrad2" x1="100%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%" stopColor="#BBDEFB"></stop>
                                        <stop offset="100%" stopColor="#2196F3"></stop>
                                    </linearGradient>
                                </defs>
                                <circle cx="35" cy="50" r="30" fill="url(#mergeGrad1)" opacity="0.8"></circle>
                                <circle cx="65" cy="50" r="30" fill="url(#mergeGrad2)" opacity="0.8"></circle>
                                <circle cx="50" cy="50" r="15" fill="#E0F2F7"></circle>
                            </svg>
                            <span className="whitespace-nowrap">{BrandName}</span>
                        </a>

                        {/* 桌面导航菜单 */}
                        <div className="md:block ml-10">
                            <DesktopDropdown/>
                        </div>
                    </div>

                    {/* 右侧功能区 */}
                    <div className="flex items-center space-x-2">
                        {/*<ul className="flex items-center space-x-2" role="list">*/}
                        {/*    <li>*/}
                        {/*        <a*/}
                        {/*            className="px-2 py-1 rounded-md text-sm font-medium bg-gray-800 hover:bg-gray-900 transition-colors"*/}
                        {/*            href="/login"*/}
                        {/*        >*/}
                        {/*            Login*/}
                        {/*        </a>*/}
                        {/*    </li>*/}
                        {/*    <li>*/}
                        {/*        <a*/}
                        {/*            className="px-2 py-1 rounded-md text-sm font-medium bg-orange-600 hover:bg-orange-500 transition-colors"*/}
                        {/*            href="/signup"*/}
                        {/*        >*/}
                        {/*            Sign Up*/}
                        {/*        </a>*/}
                        {/*    </li>*/}
                        {/*</ul>*/}

                        {/* 主题切换按钮 */}
                        <button
                            className="p-2 rounded-md
                                hover:bg-gradient-to-r from-[#FF6F61] to-[#E65F50]
                                hover:text-[#e91e63]
                                transition-colors"
                            aria-label="Light Mode"
                            onClick={() => setIsLight()}
                        >
                            {(isLight) ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
                        </button>
                    </div>
                </div>

            </nav>
        </header>
    );
};
